import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
import About from '../views/about.vue'
import Product from '../views/product.vue'
import Partner from '../views/partner.vue'

Vue.use(VueRouter)




const routes = [{
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/product',
    name: 'Product',
    component: Product
  },
  {
    path: '/partner',
    name: 'Partner',
    component: Partner
  }
]

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition && to.meta.keepAlive) {
    return savedPosition;
  }
  return {
    x: 0,
    y: 0
  };
}

const router = new VueRouter({
  routes,
  scrollBehavior,
})

export default router